var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form mortgage-calculator-form floating-label container",
      attrs: { id: "mortgage-calculator-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submitForm($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          class:
            _vm.formInitial || _vm.recalculate
              ? "mortgage-calculator-form-single-column mt-md-5"
              : "mortgage-calculator-form-multi-column"
        },
        [
          _c(
            "div",
            {
              class: _vm.formInitial || _vm.recalculate ? "row" : "row pt-md-5"
            },
            [
              _c(
                "div",
                {
                  class:
                    _vm.formInitial || _vm.recalculate
                      ? "col-sm-12 col-md-12"
                      : "pr-md-5 pr-lg-5 col-sm-12 col-lg-6 w-print-lg"
                },
                [
                  _c(
                    "div",
                    {
                      class:
                        _vm.formInitial || _vm.recalculate
                          ? "row justify-content-center"
                          : "row"
                    },
                    [
                      _c(
                        "div",
                        {
                          class:
                            _vm.formInitial || _vm.recalculate
                              ? "col-lg-6 col-md-8 col-sm-12"
                              : "col-md-12 col-sm-12"
                        },
                        [
                          _c("div", { staticClass: "form-group mb-md-4" }, [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.homePriceModel !== ""
                                    ? "floating-label is-floating"
                                    : "floating-label"
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "homeprice-field" } },
                                  [_vm._v("Home Price or Value")]
                                ),
                                _vm._v(" "),
                                _c("masked-input", {
                                  ref: "homeprice",
                                  staticClass: "form-control homeprice-input",
                                  attrs: {
                                    id: "homeprice-field",
                                    placeholder: "",
                                    name: "homeprice-field",
                                    autocapitalize: "off",
                                    autocomplete: "off",
                                    spellcheck: "false",
                                    "aria-label": "Home Price or Value",
                                    type: "text",
                                    mask: _vm.currencyMask
                                  },
                                  on: {
                                    blur: function($event) {
                                      return _vm.toggleLabel(
                                        $event,
                                        "homePrice"
                                      )
                                    },
                                    focus: function($event) {
                                      return _vm.toggleLabel($event)
                                    },
                                    input: function($event) {
                                      return _vm.handleDPAmountUpdate($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.homePriceModel,
                                    callback: function($$v) {
                                      _vm.homePriceModel = $$v
                                    },
                                    expression: "homePriceModel"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.formSubmitted &&
                                          !_vm.isMinimumValue &&
                                          !_vm.loading &&
                                          _vm.homePriceModel,
                                        expression:
                                          "formSubmitted && !isMinimumValue && !loading && homePriceModel"
                                      }
                                    ],
                                    staticClass:
                                      "mortgage-rate-calculator-form__error-message"
                                  },
                                  [
                                    _vm._v(
                                      "Please enter an amount greater than the down payment."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.formSubmitted &&
                                          !_vm.initialHomePriceState &&
                                          !_vm.isMinimumValue &&
                                          !_vm.loading &&
                                          !_vm.homePriceModel,
                                        expression:
                                          "formSubmitted && !initialHomePriceState && !isMinimumValue && !loading && !homePriceModel"
                                      }
                                    ],
                                    staticClass:
                                      "mortgage-rate-calculator-form__error-message"
                                  },
                                  [_vm._v("Please enter an amount.")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class:
                        _vm.formInitial || _vm.recalculate
                          ? "row justify-content-center"
                          : "row"
                    },
                    [
                      _c(
                        "div",
                        {
                          class:
                            _vm.formInitial || _vm.recalculate
                              ? "col-lg-4 col-md-5 col-sm-12"
                              : "col-md-8 col-sm-12"
                        },
                        [
                          _c("div", { staticClass: "form-group mb-md-4" }, [
                            _c(
                              "div",
                              {
                                class: _vm.downPaymentAmountModel
                                  ? "floating-label is-floating"
                                  : "floating-label"
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "down-payment-field" } },
                                  [_vm._v("Down Payment")]
                                ),
                                _vm._v(" "),
                                _c("masked-input", {
                                  staticClass:
                                    "form-control down-payment-input",
                                  attrs: {
                                    id: "down-payment-field",
                                    placeholder: "",
                                    name: "down-payment-field",
                                    autocapitalize: "off",
                                    autocomplete: "off",
                                    spellcheck: "false",
                                    "aria-label": "Down Payment",
                                    type: "text",
                                    mask: _vm.currencyMask
                                  },
                                  on: {
                                    blur: function($event) {
                                      return _vm.toggleLabel(
                                        $event,
                                        "downPayment"
                                      )
                                    },
                                    focus: function($event) {
                                      return _vm.toggleLabel($event)
                                    },
                                    input: function($event) {
                                      return _vm.handleDPAmountUpdate($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.downPaymentAmountModel,
                                    callback: function($$v) {
                                      _vm.downPaymentAmountModel = $$v
                                    },
                                    expression: "downPaymentAmountModel"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.formSubmitted &&
                                      !_vm.loading &&
                                      !_vm.downPaymentAmountModel,
                                    expression:
                                      "formSubmitted && !loading && !downPaymentAmountModel"
                                  }
                                ],
                                staticClass:
                                  "mortgage-rate-calculator-form__error-message"
                              },
                              [_vm._v("Please enter an amount.")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.formSubmitted &&
                                      !_vm.loading &&
                                      _vm.downPaymentAmountModel &&
                                      !_vm.isMinimumValue,
                                    expression:
                                      "formSubmitted && !loading && downPaymentAmountModel && !isMinimumValue"
                                  }
                                ],
                                staticClass:
                                  "mortgage-rate-calculator-form__error-message"
                              },
                              [
                                _vm._v(
                                  "Please enter a value lower than the Home Price."
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            _vm.formInitial || _vm.recalculate
                              ? "col-lg-2 col-md-3 col-sm-12"
                              : "col-md-4 col-sm-12"
                        },
                        [
                          _c("div", { staticClass: "form-group mb-md-4" }, [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.paymentPercentageModel.length >= 1
                                    ? "floating-label is-floating"
                                    : "floating-label"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: { for: "payment-percentage-field" }
                                  },
                                  [_vm._v("Percentage")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.paymentPercentageModel,
                                      expression: "paymentPercentageModel"
                                    }
                                  ],
                                  staticClass:
                                    "form-control payment-percentage-input",
                                  attrs: {
                                    id: "payment-percentage-field",
                                    placeholder: "",
                                    name: "payment-percentage-field",
                                    autocapitalize: "off",
                                    autocomplete: "off",
                                    spellcheck: "false",
                                    "aria-label": "LABEL HERE",
                                    type: "text",
                                    disabled: ""
                                  },
                                  domProps: {
                                    value: _vm.paymentPercentageModel
                                  },
                                  on: {
                                    blur: function($event) {
                                      return _vm.toggleLabel($event)
                                    },
                                    focus: function($event) {
                                      return _vm.toggleLabel($event)
                                    },
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.paymentPercentageModel =
                                          $event.target.value
                                      },
                                      function($event) {
                                        return _vm.HandleDPPercentUpdate($event)
                                      }
                                    ]
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class:
                        _vm.formInitial || _vm.recalculate
                          ? "row justify-content-center"
                          : "row"
                    },
                    [
                      _c(
                        "div",
                        {
                          class:
                            _vm.formInitial || _vm.recalculate
                              ? "col-lg-4 col-md-5 col-sm-12"
                              : "col-md-8 col-sm-12"
                        },
                        [
                          _c("div", { staticClass: "form-group mb-md-4" }, [
                            _c("div", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.termModel,
                                      expression: "termModel"
                                    }
                                  ],
                                  staticClass: "form-control term-length-list",
                                  attrs: {
                                    id: "length-field",
                                    "aria-label": "term length"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.termModel = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "default" } },
                                    [_vm._v("Loan Term")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: { name: "15 years", value: "15" }
                                    },
                                    [_vm._v("15 years")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: { name: "30 years", value: "30" }
                                    },
                                    [_vm._v("30 years")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.formSubmitted &&
                                        _vm.termModel === "default" &&
                                        !_vm.termModelValid &&
                                        !_vm.loading,
                                      expression:
                                        "formSubmitted && termModel==='default' && !termModelValid && !loading"
                                    }
                                  ],
                                  staticClass:
                                    "mortgage-rate-calculator-form__error-message"
                                },
                                [_vm._v("Please select a value.")]
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            _vm.formInitial || _vm.recalculate
                              ? "col-lg-2 col-md-3 col-sm-12"
                              : "col-md-4 col-sm-12"
                        },
                        [
                          _c("div", { staticClass: "form-group mb-md-4" }, [
                            _c(
                              "div",
                              {
                                class: _vm.interestRateModel
                                  ? "floating-label is-floating"
                                  : "floating-label"
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "interest-rate-field" } },
                                  [_vm._v("Interest Rate")]
                                ),
                                _vm._v(" "),
                                _c("masked-input", {
                                  staticClass:
                                    "form-control interest-rate-input",
                                  attrs: {
                                    id: "interest-rate-field",
                                    placeholder: "",
                                    name: "interest-rate-field",
                                    autocapitalize: "off",
                                    autocomplete: "off",
                                    spellcheck: "false",
                                    type: "text",
                                    mask: _vm.percentageMask
                                  },
                                  on: {
                                    blur: function($event) {
                                      return _vm.toggleLabel($event)
                                    },
                                    focus: function($event) {
                                      return _vm.toggleLabel($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.interestRateModel,
                                    callback: function($$v) {
                                      _vm.interestRateModel = $$v
                                    },
                                    expression: "interestRateModel"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.formSubmitted &&
                                      (!_vm.interestRateModel ||
                                        _vm.interestRateModel == "%" ||
                                        _vm.interestRateModel === "0%") &&
                                      !_vm.interestRateMin &&
                                      !_vm.loading,
                                    expression:
                                      "formSubmitted && (!interestRateModel || interestRateModel == '%' || interestRateModel === '0%') && !interestRateMin && !loading"
                                  }
                                ],
                                staticClass:
                                  "mortgage-rate-calculator-form__error-message"
                              },
                              [_vm._v("Please enter a value greater than 0.")]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class:
                        _vm.formInitial || _vm.recalculate
                          ? "row justify-content-center"
                          : "row"
                    },
                    [
                      _c(
                        "div",
                        {
                          class:
                            _vm.formInitial || _vm.recalculate
                              ? "col-md-6 col-sm-12"
                              : "col-md-12 col-sm-12"
                        },
                        [
                          _c(
                            "div",
                            {
                              class:
                                _vm.formInitial || _vm.recalculate
                                  ? "form-group d-flex justify-content-center"
                                  : "form-group d-flex justify-content-center justify-content-md-start"
                            },
                            [
                              _c(
                                "button",
                                {
                                  class:
                                    _vm.formInitial || _vm.recalculate
                                      ? "btn btn-primary btn-wide btn-pill btn-mortgage-submit"
                                      : "btn btn-primary btn-wide btn-pill btn-mortgage-recalc",
                                  attrs: { type: "submit" }
                                },
                                [
                                  !_vm.loading
                                    ? _c(
                                        "span",
                                        { staticClass: "mortgage-rate-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formInitial
                                                ? "Calculate"
                                                : "Re-calculate"
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mortgage-rate-calculator-form__loading"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "mortgage-rate-calculator-form__spinner"
                                          }),
                                          _vm._v(
                                            "\n                  Loading...\n                "
                                          )
                                        ]
                                      )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.formInitial && _vm.loadedPercentage,
                      expression: "!formInitial && loadedPercentage"
                    }
                  ],
                  staticClass: "col-sm-12 col-lg-6 w-print-lg"
                },
                [
                  _vm.loadedPercentage
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row mortgage-rate-calculator-form__percent my-md-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-12 d-flex justify-content-center align-items-center"
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "fs-5 mortgage-rate-calculator-form__percent-calc"
                                },
                                [
                                  _c("span", [_vm._v("$")]),
                                  _vm._v(" "),
                                  _c("animated-number", {
                                    attrs: {
                                      value: _vm.monthlyPayment,
                                      duration: 1000,
                                      formatValue: _vm.formatToPrice
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._m(0)
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.formInitial,
                  expression: "!formInitial"
                }
              ],
              class:
                !_vm.formInitial && !_vm.recalculate
                  ? "row mortgage-disclaimer-container"
                  : "row mortgage-disclaimer-container justify-content-center"
            },
            [
              _c(
                "div",
                {
                  class:
                    !_vm.formInitial && !_vm.recalculate
                      ? "col-md-12 col-sm-12"
                      : "col-md-6 col-sm-12"
                },
                [
                  _c("hr", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.formInitial,
                        expression: "!formInitial"
                      }
                    ],
                    class:
                      !_vm.formInitial && !_vm.recalculate
                        ? "mortgage-rate-calculator-form__separator"
                        : "mortgage-rate-calculator-form__separator"
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.formInitial,
                  expression: "!formInitial"
                }
              ],
              class:
                !_vm.formInitial && !_vm.recalculate
                  ? "row mortgage-disclaimer-container"
                  : "row mortgage-disclaimer-container justify-content-center"
            },
            [
              _c(
                "div",
                {
                  class:
                    !_vm.formInitial && !_vm.recalculate
                      ? "col-md-12 col-sm-12"
                      : "col-md-12 col-sm-12"
                },
                [_c("div", { domProps: { innerHTML: _vm._s(_vm.disclaimer) } })]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            class: _vm.formInitial || _vm.recalculate ? "row" : "row pt-md-5"
          })
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "mortgage-rate-calculator-form__percentInfo" },
      [
        _c(
          "div",
          { staticClass: "mortgage-rate-calculator-form__percentInfo-sign" },
          [_vm._v("*")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }